import { useLocation } from '@ecomm/framework/useLocation'

function isWildcardRouteMatch(route: string, path: string): boolean {
  const regex = new RegExp(
    `^${route.replace(/\./g, '\\.').replace(/\*/g, '.*')}$`
  )
  return regex.test(path)
}

function hasWildcardMatch(set: ReadonlySet<string>, path: string): boolean {
  return [...set].some(route =>
    route.includes('*') ? isWildcardRouteMatch(route, path) : route === path
  )
}

const EXCLUDED_ROUTES = new Set([
  '/cart*',
  '/payment-page',
  '/alarm-sensors',
  '/business*',
  '/build-my-system'
])

/**
 * Hook that determines if AI Chat Bot should not be rendered on the user's current route. Currently
 * only returns true if the user is on one of the following pages:
 * - /cart* (wildcard for Cart and Checkout routes)
 * - /payment-page
 * - /alarm-sensors
 * - /business* (wildcard for all Business routes)
 * - /build-my-system (BMS and System Advisor)
 * @returns boolean
 */
export function useExcludeAIChatForRoute() {
  const location = useLocation()

  return hasWildcardMatch(EXCLUDED_ROUTES, location.pathname)
}
